import React from 'react'
import { Link } from 'react-router-dom';
import Nav from "../Nav/Nav";
import { connect } from "react-redux";

const Aside = ({user, ...props}) => {
    return (
        <div className="aside">
            <div className="sidebar" >
                <diiv className="main-logo">
                    <Link to="/" className='chitkara-logo'>
                        <img src='../../../../images/logo2.png' alt="Logo" />
                    </Link>
                </diiv>
                <Nav />              
            </div>
            <div className='nav-foot'>
                <hr/>
                    <Link to="/auth/login">
                        <div className='logout-info'>
                            <div className="avatar-block">
                                <div className="e-avatar">{user?.user?.name.slice(0,1)}</div>
                            </div>
                            <div className='footer-avator'>
                                <div className='user-info'>
                                    <span>{user?.user?.name}</span>
                                    <img className='logout-icon' src='../../../../images/logout.svg' alt='Icon' />
                                </div>
                                <p>
                                    <abbr className="show-user-email" title={user?.user?.email}>{user?.user?.email}</abbr>
                                </p>
                            </div>
                        </div>
                    </Link>
                </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};

const mapDispatchToProps = (dispach) => {
    return {
        dispatchLogin: (user) => {
            dispach({ type: "Login", data: user });
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Aside);
